(() => {
  const initialize = scope => {
    scope.querySelectorAll('[data-pp-navigation]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const header = root.closest('.pp-header-wrapper');
      const nav = root.querySelector('.pp-nav');
      const dropdowns = [...root.querySelectorAll('.pp-nav__details')];
      const dialog = root.querySelector('[data-pp-nav-dialog]');
      const openers = [...header.querySelectorAll('[data-pp-nav-open]')];
      const levels = [...dialog.querySelectorAll('[data-pp-nav-level]')];
      const wide = matchMedia('(min-width: 1101px)');
      const hover = matchMedia('(hover: hover) and (pointer: fine)');
      const controller = new AbortController();
      const signal = controller.signal;
      const on = (el, event, handler) => el.addEventListener(event, handler, { signal });
      const stockRequests = new Map();
      const checkStarterAdvice = scope => {
        scope.querySelectorAll('[data-pp-starter-advice]').forEach(async link => {
          const key = link.dataset.productId;
          let entry = stockRequests.get(key);
          if (!entry || Date.now() - entry.time > 60000) {
            root.querySelectorAll('[data-pp-starter-advice]').forEach(peer => { if (peer.dataset.productId === key) peer.hidden = true; });
            entry = { time: Date.now(), request: (async () => {
              const current = document.querySelector('[data-pp-starter-stock]');
              if (current) {
                try { const stock = JSON.parse(current.textContent); if (stock.productId === key && !stockRequests.has(key)) return stock.available === true; } catch {}
              }
              const url = new URL(link.href, location.origin);
              if (url.origin !== location.origin) return false;
              const request = new AbortController();
              const timeout = setTimeout(() => request.abort(), 12000);
              const abort = () => request.abort();
              signal.addEventListener('abort', abort, { once: true });
              try {
                const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: request.signal });
                if (!response.ok) return false;
                const html = await response.text();
                const match = html.match(/<script type="application\/json" data-pp-starter-stock>([^<]+)<\/script>/);
                if (!match) return false;
                const stock = JSON.parse(match[1]);
                return stock.productId === key && stock.available === true;
              } catch { return false; }
              finally { clearTimeout(timeout); signal.removeEventListener('abort', abort); }
            })() };
            stockRequests.set(key, entry);
          }
          const available = await entry.request;
          if (signal.aborted || stockRequests.get(key) !== entry) return;
          root.querySelectorAll('[data-pp-starter-advice]').forEach(peer => { if (peer.dataset.productId === key) peer.hidden = !available; });
        });
      };
      let openTimer;
      let closeTimer;
      let returnFocus;
      let previousOverflow;
      const clearTimers = () => { clearTimeout(openTimer); clearTimeout(closeTimer); };
      const setExpanded = item => item.querySelector('summary').setAttribute('aria-expanded', String(item.open));
      const closeDropdowns = except => {
        dropdowns.forEach(item => {
          if (item !== except) { item.open = false; setExpanded(item); }
        });
      };
      const sizePanel = () => nav.style.setProperty('--pp-nav-available', `${Math.max(120, innerHeight - nav.getBoundingClientRect().bottom - 16)}px`);
      dropdowns.forEach(item => {
        const summary = item.querySelector('summary');
        on(item, 'toggle', () => {
          setExpanded(item);
          if (item.open) { closeDropdowns(item); sizePanel(); checkStarterAdvice(item); }
        });
        on(item, 'pointerenter', () => {
          if (!wide.matches || !hover.matches) return;
          clearTimers();
          checkStarterAdvice(item);
          openTimer = setTimeout(() => { closeDropdowns(item); sizePanel(); item.open = true; setExpanded(item); }, 130);
        });
        on(item, 'pointerleave', () => {
          if (!wide.matches || !hover.matches) return;
          clearTimers();
          if (!item.contains(document.activeElement)) closeTimer = setTimeout(() => { item.open = false; setExpanded(item); }, 220);
        });
        on(item, 'focusout', event => {
          if (event.relatedTarget && !item.contains(event.relatedTarget)) { clearTimers(); item.open = false; setExpanded(item); }
        });
        on(summary, 'keydown', event => {
          if (event.key === 'ArrowDown') {
            event.preventDefault(); clearTimers(); closeDropdowns(item); item.open = true; setExpanded(item); sizePanel();
            item.querySelector('.pp-nav__panel a')?.focus();
          }
        });
      });
      const showLevel = (id, back = false) => {
        const target = levels.find(level => level.id === id);
        if (!target) return;
        checkStarterAdvice(target);
        const previous = levels.find(level => !level.hidden);
        levels.forEach(level => { level.hidden = level !== target; });
        dialog.querySelectorAll('[data-pp-nav-next]').forEach(button => button.setAttribute('aria-expanded', String(button.dataset.ppNavNext === id)));
        dialog.querySelector('.pp-nav-drawer__body').scrollTop = 0;
        const priorButton = back && [...target.querySelectorAll('[data-pp-nav-next]')].find(button => button.dataset.ppNavNext === previous?.id);
        (priorButton || target.querySelector('h2')).focus({ preventScroll: true });
      };
      openers.forEach(button => on(button, 'click', () => {
        clearTimers(); closeDropdowns(); returnFocus = button;
        levels.forEach((level, index) => { level.hidden = index !== 0; });
        dialog.querySelectorAll('[data-pp-nav-next]').forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
        if (!dialog.open) {
          previousOverflow = document.body.style.overflow;
          dialog.showModal();
          document.body.style.overflow = 'hidden';
        }
        openers.forEach(opener => opener.setAttribute('aria-expanded', 'true'));
        dialog.querySelector('[data-pp-nav-close]').focus();
      }));
      on(dialog, 'click', event => {
        const next = event.target.closest('[data-pp-nav-next]');
        const back = event.target.closest('[data-pp-nav-back]');
        if (next) showLevel(next.dataset.ppNavNext);
        else if (back) showLevel(back.dataset.ppNavBack, true);
        else if (event.target.closest('[data-pp-nav-close]')) dialog.close();
        else if (event.target === dialog) {
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        }
      });
      on(dialog, 'close', () => {
        document.body.style.overflow = previousOverflow || '';
        openers.forEach(button => button.setAttribute('aria-expanded', 'false'));
        if (returnFocus?.isConnected && returnFocus.getClientRects().length) returnFocus.focus({ preventScroll: true });
      });
      on(document, 'pointerdown', event => { if (!nav.contains(event.target)) { clearTimers(); closeDropdowns(); } });
      on(document, 'keydown', event => {
        if (event.key !== 'Escape' || dialog.open) return;
        const current = dropdowns.find(item => item.open);
        if (current) { event.preventDefault(); clearTimers(); closeDropdowns(); current.querySelector('summary').focus(); }
      });
      on(window, 'resize', () => { sizePanel(); if (wide.matches && dialog.open) dialog.close(); });
      on(document, 'shopify:section:unload', event => {
        if (!event.target.contains(root)) return;
        if (dialog.open) dialog.close();
        clearTimers(); controller.abort();
      });
    });
  };
  if (window.ppNavigationInitialized) return;
  window.ppNavigationInitialized = true;
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
